module.exports = __webpack_public_path__ + "PERUVIANserve-5.fd29ed7e.png";